import { Routes, Route, Navigate } from 'react-router-dom';

import AdminLayout from 'layouts/admin';
import AuthLayout from 'layouts/auth';
import { useState, useEffect } from 'react';
import { AlertProvider } from 'context/alertContext';
import SuccessAlert from 'components/alerts/successAlert';
import ErrorAlert from 'components/alerts/errorAlert';

const PrivateRoute = ({ children }: any) => {
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem('accessToken'),
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setAccessToken(localStorage.getItem('accessToken'));
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('accessToken', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('accessToken', handleStorageChange);
    };
  }, []);

  return accessToken ? children : <Navigate to="/auth" replace />;
};

const App = () => {
  return (
    <AlertProvider>
      <SuccessAlert />
      <ErrorAlert />

      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
        <Route
          path="admin/*"
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AlertProvider>
  );
};

export default App;
